export default "__VITE_ASSET__2c733d97__"